import $ from 'sbf-design-system/js/jquery';
import 'sbf-design-system/js/lib/parsley';
import 'rails-ujs';
import Banner from 'sbf-design-system-component/banners/banner';
import 'sbf-design-system-component/broadcast_messages/broadcast_message';
import BraintreeHostedFields from '../lib/braintree-hosted-fields';
import 'sbf-design-system-component/forms/base';
import initDeviceData from '../lib/braintree-device-data';

let banner;
try {
  if (window.parent && window.parent.SBFBanner) {
    banner = window.parent.SBFBanner;
  } else {
    banner = Banner;
  }
} catch (e) {
  banner = Banner;
}

const braintreeClient = window.braintree && window.braintree.client;
const paypalCheckout = window.braintree && window.braintree.paypalCheckout;
const { paypal } = window;

const braintreeAvailable = window.gon.braintree_token && braintreeClient && paypalCheckout && paypal;
const clientPaymentScriptsSucceeded = window.braintree &&
  window.braintree.client &&
  window.braintree.paypalCheckout &&
  window.paypal;

let $flow = 'checkout'; // default is checkout

const processingFeePercentage = window.gon.transaction_fee;

const $widgetDonationDetailsAmount = $('#donation_details_amount');
const $widgetDonationDetails = $('#donation_details');
const $giveButton = $('#next_step');
const $widgetStepTitle = $('#widget_step_title');
const $stepId = $('#step_id');
const $stepIdContainer = $('#step_id_container');
const $stepDetailsContainer = $('#step_details_container');

const $paymentForm = $('#payment_form');
const $paymentButton = $('#payment_button');

const $donationAmountField = $('#donation_amount');

const oneTimeRec = window.gon.suggested_giving.once;
const monthlyRec = window.gon.suggested_giving.monthly;

let valueClicked = false;

// return a size in px for payment button heights
function paymentButtonHeightQuery () {
  if ($('body').width() > 760) {
    return 35;
  } else {
    return 55;
  }
}

// set the buttons to the same size as when loaded
(function setPaymentButtonClass () {
  let paymentButtonClass = 'payment-buttons__small';
  if (paymentButtonHeightQuery() === 55) {
    paymentButtonClass = 'payment-buttons__large';
  }
  $('.donate-by').children().addClass(paymentButtonClass);
})();

function braintreeError () {
  if (window.gon.braintree_token && !clientPaymentScriptsSucceeded) {
    $('.processor-error .braintree-down').append('<div>You may have an issue with a VPN or firewall causing this. Please contact St. Baldrick\'s support at (888) 899-2253.</div>');
  }
  $('.processor-error, .processor-error .braintree-down').css('display', 'block');
  $('#donate_monthly').prop('disabled', true);
}

if (!braintreeAvailable) {
  $(braintreeError);
} else {
  braintreeClient.create({
    authorization: window.gon.braintree_token
  }, function (clientErr, clientInstance) {
    // Stop if there was a problem creating the client.
    if (clientErr) {
      log('Error creating client:', clientErr);
      return;
    }

    paypalCheckout.create({
      client: clientInstance
    }, function (createErr, paypalCheckoutInstance) {
      if (createErr) {
        log('Error!', createErr);
        return;
      }

      paypal.Button.render({
        env: window.gon.paypal_env,
        style: {
          tagline: false,
          size: 'responsive',
          height: 55,
          color: 'gold',
          shape: 'rect',
          label: 'paypal'
        },
        funding: {
          disallowed: [paypal.FUNDING.CREDIT]
        },
        onClick: function () {
        },
        commit: true,
        payment: function () {
          const amount = $('#amount_with_fee').val().replace(/,/g, '');
          const formattedAmount = parseFloat(amount).toFixed(2).replace(/./g, function (c, i, a) {
            return i && c !== '.' && ((a.length - i) % 3 === 0) ? `,${c}` : c;
          }).replace(/\.00$/, '');

          const paymentOptions = {
            flow: $flow,
            currency: 'USD',
            amount,
            enableBillingAddress: true
          };
          if ($flow === 'checkout') {
            paymentOptions.intent = 'sale';
          } else {
            paymentOptions.billingAgreementDescription = `Give $${formattedAmount} every month to support lifesaving childhood cancer research.`;
          }
          log(paymentOptions);
          return paypalCheckoutInstance.createPayment(paymentOptions);
        },
        onAuthorize: function (data, actions) {
          return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
            $('#payment_method_nonce').val(`${payload.nonce}`);
            $('#payment_gateway').val('braintree');
            $('#payment_method').val('paypal');

            // update form fields with info from paypal

            if (payload.details.billingAddress) {
              // concat with empty string to cast to string
              $('#address1').val(`${payload.details.billingAddress.line1}`);
              $('#address2').val(`${payload.details.billingAddress.line2}`);
              $('#city').val(`${payload.details.billingAddress.city}`);
              $('#state').val(`${payload.details.billingAddress.state}`);
              $('#zip').val(`${payload.details.billingAddress.postalCode}`);
            }

            $('#cc_first_name').val(`${payload.details.firstName}`);
            $('#last_name').val(`${payload.details.lastName}`);
            $('#email').val(`${payload.details.email}`);
            $('select[name="country"]').val(payload.details.countryCode.toUpperCase());

            disablePaymentButtons();
            log('disable payment buttons - paypal processing');

            log('posting payment');
            postPaymentForm();
          });
        },
        onCancel: function (data) {
          log('checkout.js payment cancelled', JSON.stringify(data, 0, 2));

          enablePaymentButtons();
          log('enable payment buttons - paypal cancelled');
        },
        onError: function (err) {
          log('checkout.js error', err);
          $.post('/website-ruby/log/create', { message: JSON.stringify(err) });
          banner.showError('Invalid information. Please verify your information is correct and then try again.', false, 4000);

          enablePaymentButtons();
          log('enable payment buttons - paypal errored');
        }

      }, '#paypal-button'); // the PayPal button will be rendered in an html element with the id `paypal-button`
    });
  });
}

function log () {
  // turning off for live
  if (window.console) {
    console.log.apply(console, [].slice.call(arguments));
  }
}

// Basic Utility Functions

// Sets the amount on initial page load, either with a url param or the default suggested giving
// Only gets called during page load
function setAmount (value) {
  let value2 = value;
  // Check if a value has been passed in
  if (typeof value2 === 'undefined') {
    // if a value isn't specificed, then call `getAmount()`,
    value2 = getAmount();
  }

  // Set the donationAmountField value
  $donationAmountField.val(value2);
  setFeeAmount();
}

// Updates the details amount on subsequent steps based on the amount in the button
// Gets called when you update the amount with fee, change donation type, or the suggested amounts change
function updateDonationDetailsAmount (amount) {
  let amount2 = amount;
  if (typeof amount2 === 'undefined') {
    // if a value isn't specificed, then call `getAmount()`,
    amount2 = getAmount();
  }

  let message = `$${formatAmount(amount2)}`;
  const donationType = $('#donation_type').val();

  const formattedAmount = formatAmount($donationAmountField.val());
  setAmountOnButton(formattedAmount);

  if (donationType === 'monthly') {
    message += ' Monthly';
  }

  $widgetDonationDetailsAmount.text(message);
}
updateDonationDetailsAmount();

// Sets the formatted amount in the button as user enters digits, validating the amount
// Also sets the fee amount
$('#donation_amount').on('keyup', validateNumber);

const validNumber = /^\d*\.?\d*$/;
function validateNumber () {
  const amount = $donationAmountField.val().replace(/[,\s]/g, '');
  $donationAmountField.val(amount);

  if (validNumber.test(amount)) {
    const formattedAmount = formatAmount($donationAmountField.val());
    setAmountOnButton(formattedAmount);
    setFeeAmount();
    return true;
  } else {
    console.log('amount is invalid');
    banner.showError('Please enter a valid amount.', true, 4000);
    $donationAmountField.closest('.inline-input').addClass('invalid');
    return false;
  }
}

const $creditCardNum = $('#card_number');

$creditCardNum.on('focusout change keyup', (e) => {
  if (e.which && e.which !== 13) { return; } // only trigger on [enter] keyup
  $creditCardNum.val($creditCardNum.val().replace(/\s+/g, ''));
});

// Takes the input from the user (or param, if applicable) and updates the amount on the button in first step
// Gets called by wigitInit, updateDonationDetailsAmount, and upon user input to Other field
function setAmountOnButton (amount) {
  const parsed = parseFloat(amount.replace(/,/g, ''));
  let formattedAmount = '0';

  if (isNaN(parsed) || parsed === 0) {
    $giveButton.val('Donate $0.00');
  } else {
    formattedAmount = parsed.toFixed(2).replace(/./g, (c, i, a) => {
      return i && c !== '.' && ((a.length - i) % 3 === 0) ? `,${c}` : c;
    });

    if ($('#donation_type').val() === 'monthly') {
      $giveButton.val(`Donate $${formattedAmount} Monthly`);
    } else {
      $giveButton.val(`Donate $${formattedAmount}`);
    }
  }
}

// This function gets the selected amount from the suggestive giving options on the page and returns a value
// Gets called via setAmount, updateDonationDetailsAmount, setFeeAmount
function getAmount () {
  if ($('#otherAmount').prop('checked')) {
    if ($donationAmountField.val() === undefined || $donationAmountField.val().length === 0) {
      return '';
    } else {
      return $donationAmountField.val();
    }
  } else {
    return $('input[name=amounts]:checked').val();
  }
}

// Helper function to format the amounts
function formatAmount (amount) {
  return parseFloat(amount.toString().replace(/,/g, '')).toFixed(2).replace(/./g, function (c, i, a) {
    return i && c !== '.' && ((a.length - i) % 3 === 0) ? `,${c}` : c;
  });
}

// Gets any params from the URL to use, if applicable
function getUrlParams () {
  const paramsList = []; let param;

  const url = window.location.href;
  const params = url.replace(/^[^?]*\?([^#]*)#?.*$/, '$1').split('&');

  for (let i = 0; i < params.length; i++) {
    param = params[i].split('=');
    paramsList.push(param[0]);
    paramsList[param[0]] = param[1];
  }
  return paramsList;
}
const $urlParams = getUrlParams();

// Set the fee based on the amount in the other field/suggested donation and set the fee amount in the checkbox label
// Gets called on user input to donation amount, when the Donate button is clicked, and on initial load
function setFeeAmount () {
  // get the current amount on button
  const currentButtonAmount = $donationAmountField.val();
  const processingFee = ((processingFeePercentage * currentButtonAmount) / 100).toFixed(2).replace(/./g, (c, i, a) => {
    return i && c !== '.' && ((a.length - i) % 3 === 0) ? `,${c}` : c;
  });
  $('#fee').text(processingFee);
}

// Customize the widget if the primary and/or secondary url params are passed in
const $primaryColorParam = $urlParams.primary;
const $secondaryColorParam = $urlParams.secondary;

function customizeWidget (primary, secondary) {
  const primaryColor = encodeURIComponent(primary);
  const classBase = 'tk-widget-button--';

  $giveButton.addClass(classBase + primaryColor);
}

// NOW START DOING THINGS

// first step is step "0"
let activeStep = 0;
const finalStep = 4;
const signInStep = 99;

// Grab the amount from the URL param
const urlAmount = parseFloat($urlParams.amount).toFixed(2);

if (isNaN(urlAmount)) {
  // urlAmount is NaN so this probably means that there isn't a urlAmount so,
  // call setAmount() to set the donation amount based on the suggestive giving options
  setAmount();
} else {
  // Set the donation amount using the urlAmount variable via the param passed in
  setAmount(urlAmount);
}

function widgetInit () {
  const initialAmount = parseFloat($urlParams.amount).toFixed(2);
  const initialDonationType = $urlParams.donation_type;

  const profileID = $('#give_profile_id').val();

  customizeWidget($primaryColorParam, $secondaryColorParam);

  if ((initialDonationType === 'monthly') && isNaN(initialAmount)) {
    // if monthly is set, but the amount is not, drop the user at the first step
    // and toggle on the monthly button
    $('#donate_monthly').prop('checked', true);
    updateSuggestiveAmounts(monthlyRec);
    $donationAmountField.val($('#amounts_2').val());
  } else if (!isNaN(initialAmount) && initialDonationType) {
    // if the amount is set and a type is set, skip to the next step

    if (initialDonationType === 'monthly') {
      $('#donate_monthly').prop('checked', true);
      updateSuggestiveAmounts(monthlyRec);
    }

    log('SKIPPING STEP 0');
    let nextStep = 1;

    if (profileID) {
      // if this profileID is populated, it means the user went through the inline
      // sign in form, so skip them to the final step
      nextStep = finalStep;
    }

    hideStep(activeStep, function () {
      showStep(nextStep);
    });

    $stepId.text(nextStep);
    $stepIdContainer.addClass('visible');
    $stepDetailsContainer.addClass('visible');
    $paymentForm.addClass('form__in-progress');
    $widgetDonationDetails.addClass('visible');

    setDonationType(initialDonationType);
    updateAmountWithFee();

    activeStep = nextStep;
  }
  const formattedAmount = formatAmount($donationAmountField.val());
  setAmountOnButton(formattedAmount);
}
widgetInit();

if ($('#otherAmount').is(':checked') === true) {
  showOtherAmount();
}

$('#otherAmountClose').on('click', function (click) {
  hideOtherAmount();
});

let previousSelectedAmount = $('input[name=amounts]:checked').val();

$('input[name=amounts]').change(function () {
  if ($('#otherAmount').is(':checked')) {
    showOtherAmount();
  } else {
    previousSelectedAmount = $('input[name=amounts]:checked').val();
    $donationAmountField.val(previousSelectedAmount);
  }
  setAmount();
});

$('input[name=amounts]').on('click', () => {
  valueClicked = true;
});

// Updates hidden fields with the fee amount and the total donation including fee
// Gets called when the Donate button is clicked
function updateAmountWithFee () {
  // get the current amount on button
  const currentButtonAmount = $donationAmountField.val();
  const processingFee = ((processingFeePercentage * currentButtonAmount) / 100).toFixed(2);

  let newAmount;
  if ($('#donation_fee_covered').is(':checked')) {
    newAmount = (parseFloat(currentButtonAmount) + parseFloat(processingFee)).toFixed(2).replace(/./g, (c, i, a) => {
      return i && c !== '.' && ((a.length - i) % 3 === 0) ? `,${c}` : c;
    });
    $('#fee_amount').val(processingFee);
  } else {
    newAmount = parseFloat(currentButtonAmount).toFixed(2).replace(/./g, (c, i, a) => {
      return i && c !== '.' && ((a.length - i) % 3 === 0) ? `,${c}` : c;
    });
  }

  if ($('#donation_type').val() === 'monthly') {
    $paymentButton.val(`Donate $${newAmount} Monthly`);
  } else {
    $paymentButton.val(`Donate $${newAmount}`);
  }

  updateDonationDetailsAmount(newAmount);
  const strippedAmount = newAmount.replace(/,/g, '');
  $('#amount_with_fee').val(strippedAmount);
}
$('#donation_fee_covered').change(updateAmountWithFee);

// Update the details if the donation amounts change
$donationAmountField.add('input[name=amounts]').change(function () {
  updateDonationDetailsAmount(getAmount());
  updateAmountWithFee();
});

// Checks to see what the toggle is set to and updates the type accordingly
$('input[name=donation-type]').change(function () {
  if ($('#donate_once').is(':checked')) {
    setDonationType('once');
  } else {
    setDonationType('monthly');
  }
  changeDonationType();
});

$('#credit-button').on('click', function (click) {
  click.preventDefault();
  nextStep();
});

// we might be able to ditch this for the TK module
// show/hide state/country/region based on selected country (country is "empty" by default)
const country = $('#country');
const dataISOCompliantCountries = JSON.parse(country.attr('data-iso-compliant-countries'));
country.change(() => {
  if (dataISOCompliantCountries.includes(country.val())) {
    $('#state').prop('disabled', false);
    $('#region').prop('disabled', true);
  } else {
    $('#state').prop('disabled', true);
    $('#region').prop('disabled', false);
  }

  if (['CA', 'US'].includes(country.val())) {
    $('#state').prop('required', true);
  } else {
    $('#state').prop('required', false);
  }

  if (country.val() === 'US') {
    $('[for="zip"]').text('Zip');
  } else {
    $('[for="zip"]').text('Postal Code');
  }
});

$('[name=back], .give__back-icon .prev-step').on('click', function (click) {
  click.preventDefault();
  previousStep();
});

$('[name=continue], .give__continue-icon, .next-step').on('click', function (click) {
  click.preventDefault();
  updateAmountWithFee();
  nextStep();

  $('#country').trigger('change', [true]);
});

$('#backToBeginning').on('click', function (click) {
  click.preventDefault();
  $('.donation-details').removeClass('visible');
  hideStep(activeStep, function () {
    showStep(0);
  });

  activeStep = 0;
});

$paymentButton.click(e => {
  log('form submit triggered');
  e.preventDefault();

  BraintreeHostedFields.validate();

  if (!validateActiveStep()) {
    $paymentButton.prop('disabled', false);
    $('.prev-step').prop('disabled', false);
    return false;
  }

  if ($('.g-recaptcha').length) {
    // recaptcha callback below will submit the form
    window.grecaptcha.execute();
    return;
  }
  submit();
});

window.captchaCallback = function (token) {
  $('.g-recaptcha').addClass('g-recaptcha-submitted');
  $('.g-recaptcha-response').val(token);
  submit();
};

window.errorCaptchaCallback = function () {
  banner.showError('This donation cannot be processed. Please reload the page and try submitting your donation again.', true);
  return false;
};

function submit () {
  if ($paymentButton.prop('disabled') || !validateActiveStep()) {
    return false;
  }

  try {
    BraintreeHostedFields.instance.tokenize(function (tokenizeErr, payload) {
      if (tokenizeErr) {
        console.error(JSON.stringify(tokenizeErr.message));
        paymentErrorResponse(tokenizeErr);
      } else {
        $('#payment_method_nonce').val(payload.nonce);
        $('#payment_gateway').val('braintree');
        postPaymentForm();
      }
    });
  } catch (e) {
    console.error(JSON.stringify(e.message));
    paymentErrorResponse(e);
  }
}

function paymentErrorResponse (response) {
  $.post('/donate/log/create', { message: JSON.stringify(response) });
  banner.showError('There was an error processing your payment. Please try again later.');
  $paymentButton.prop('disabled', false);
  $('.prev-step').prop('disabled', false);
  if ($('.g-recaptcha').length) {
    window.grecaptcha.reset();
  }
  return false;
}

// ignore enter key to avoid problems
$paymentForm.find('input').on('keydown', function (kd) {
  if (kd.keyCode === 13) {
    return false;
  }
});

$paymentForm.find('input').on('keyup', formFieldChangeHandler);
$paymentForm.find('select').on('change', formFieldChangeHandler);

$paymentForm.on('keyup', function (e) {
  if (e.keyCode === 13) {
    formEnterKeyHandler(e);
  }
});

if ($urlParams.amount !== undefined && $urlParams.amount !== 0) {
  setDonationAmountUrl();
  showOtherAmount();
  setFeeAmount();
  $('#otherAmount').prop('checked', true);
}

function showOtherAmount () {
  $('#donationWrapper').hide();
  $('#otherDonationWrapper').show();
  $donationAmountField.trigger('keyup');
}

function setDonationAmountUrl () {
  let temp = parseFloat($urlParams.amount).toFixed(2) || 0;
  if (temp === 0) {
    temp = $('#donation_amount').val();
  }
  $donationAmountField.val(temp);
}

// Handles changing donation type
function changeDonationType () {
  let previousAmount = $('input[name=amounts]:checked').val();
  if ($('#otherAmount').prop('checked')) { previousAmount = $donationAmountField.val(); }
  // Check which donation type to switch to
  if ($('#donate_monthly').prop('checked')) {
    updateSuggestiveAmounts(monthlyRec);
    if (!$('#otherAmount').prop('checked')) { changeSelection(monthlyRec, previousAmount); }
  } else {
    updateSuggestiveAmounts(oneTimeRec);
    if (!$('#otherAmount').prop('checked')) { changeSelection(oneTimeRec, previousAmount); }
  }
  setAmount();
  updateDonationDetailsAmount();
}

// Changes the selected value if it exists
// Populates the other field otherwise
function changeSelection (array, amount) {
  if (!valueClicked) {
    $('#amounts_2').prop('checked', true).trigger('change');
    return;
  }
  if (array.includes(Number(amount))) {
    $(`input[name=amounts][value=${amount}]`).prop('checked', true).trigger('change');
  } else {
    if ($('#otherAmount').prop('checked')) { return; }
    $('#otherAmount').prop('checked', true).trigger('change');
    $donationAmountField.val(amount);
    showOtherAmount();
  }
}

// Change values being displayed
function updateSuggestiveAmounts (array) {
  // Set new values in the form
  array.forEach(function (element, index) {
    const label = $(`.opt${index + 1}`);
    const form = $(`#${label.attr('for')}`);
    label.text(`$${element}`);
    form.val(element);
  });
}

function hideOtherAmount () {
  $('#otherDonationWrapper').hide();
  $('#donationWrapper').show();
  if ($(`input[name=amounts][value="${$donationAmountField.val()}"]`).length > 0) {
    $(`input[name=amounts][value="${$donationAmountField.val()}"]`).prop('checked', true).trigger('change');
  } else {
    $('#amounts_2').prop('checked', true).trigger('change');
  }
}

function disablePaymentButtons () {
  $('#credit-button, #paypal-button').prop('disabled', true);
  $('.apple-pay-button, .gpay-button').attr('disabled', 'disabled');
}

function enablePaymentButtons () {
  $('#credit-button, #paypal-button').prop('disabled', false);
  $('.apple-pay-button, .gpay-button').removeAttr('disabled');
}

function formFieldChangeHandler (e) {
  if (($(this).closest('.inline-input').hasClass('invalid') || $(this).hasClass('invalid')) && validateField(this)) {
    if (activeStep === 0) {
      $(this).removeClass('invalid');
    } else {
      $(this).closest('.inline-input').removeClass('invalid');
    }

    $paymentForm.removeClass('form__error');

    // special handling for state/province/region
    if (this.name === 'state') {
      $('#states_wrapper').addClass('invalid');
    }
  }
}

function formEnterKeyHandler (e) {
  switch (activeStep) {
  case signInStep:
    $('#give_sign_in_submit').triggerHandler('click');
    break;
  case finalStep:
    $paymentButton.triggerHandler('click');
    break;
  default:
    if (e.target.classList.contains('next-step')) {
      nextStep();
    } else if (e.target.classList.contains('prev-step')) {
      previousStep();
    }
    break;
  }
}

function setDonationType (donationType) {
  $('#donation_type').val(donationType);

  if (donationType === 'monthly') {
    $paymentButton.addClass('give__donate-button--monthly');
    $('.credit-card').addClass('monthly');
    $flow = 'vault';
  } else {
    $paymentButton.removeClass('give__donate-button--monthly');
    $flow = 'checkout';
    $('.credit-card').removeClass('monthly');
  }

  updateDonationDetailsAmount($donationAmountField.val());
}

function nextStep () {
  if (!validateActiveStep()) {
    return false;
  }

  log('going to the next step');
  let nextStep = activeStep + 1;

  // if signed in, skip the middle steps
  const profileId = $('#give_profile_id').val();
  if (activeStep === 1 && profileId) {
    nextStep = 4;
  }

  if (nextStep < 0) { nextStep = 0; }
  if (nextStep === activeStep) { return; } // already there

  hideStep(activeStep, function () {
    showStep(nextStep);
  });

  $stepId.text(nextStep);

  $stepIdContainer.addClass('visible');
  $stepDetailsContainer.addClass('visible');
  $widgetDonationDetails.addClass('visible');

  if (activeStep === 0) {
    $paymentForm.addClass('form__in-progress');
  }

  activeStep = nextStep;
}

function previousStep () {
  log('going to the previous step');
  let nextStep = activeStep - 1;

  // if signed in, skip the middle steps
  const profileId = $('#give_profile_id').val();
  if (activeStep === 4 && profileId) {
    nextStep = 1;
  }

  if (nextStep > finalStep) { nextStep = finalStep; }
  if (nextStep === activeStep) { return; } // already there

  hideStep(activeStep, function () {
    showStep(nextStep);
  });

  if (nextStep > 0) {
    $stepIdContainer.addClass('visible');
    $stepDetailsContainer.addClass('visible');
    $stepId.text(nextStep);
  } else {
    $stepIdContainer.removeClass('visible');
    $stepDetailsContainer.removeClass('visible');
    $paymentForm.removeClass('form__in-progress');
  }

  activeStep = nextStep;
}

function hideStep (stepId, then = function () {}) {
  $(`.step-${stepId}`).fadeOut('fast', then);
}

function showStep (stepId) {
  updateTitle(stepId);

  $(`.step-${stepId}`).fadeIn();
}

function updateTitle (stepId) {
  const currentStepTitle = $(`.give--step.step-${stepId}`).data('title');

  $widgetStepTitle.text(currentStepTitle);
}

function validateActiveStep () {
  const $step = $(`.give--step.step-${activeStep}`);
  const invalidFieldSelector = BraintreeHostedFields.getFirstInvalidField();
  let returnValue = true;

  $step.find('[required]').each(function () {
    // generic field validation as defined in markup
    if (!validateField(this)) {
      log('field is not valid');
      banner.showError($(this).attr('data-parsley-error-message'), true, 2500);

      if (!window.navigator.userAgent.match(/iPhone/i)) {
        this.focus();
      }

      if (activeStep === 0) {
        $(this).addClass('invalid');
      } else {
        $(this).closest('.inline-input').addClass('invalid');
      }

      // special handling for state/province/region
      if (this.name === 'state') {
        $('#states_wrapper').addClass('invalid');
      }

      returnValue = false;
      $paymentForm.addClass('form__error');
      return false; // stop looping
    }
  });

  if (!window.navigator.userAgent.match(/iPhone/i)) {
    if (invalidFieldSelector) {
      BraintreeHostedFields.instance.focus(invalidFieldSelector);
    }
  }

  if (returnValue) {
    const $amountInput = $donationAmountField;
    const amount = $amountInput.val().replace(/,/g, '');
    $amountInput.val(amount);

    if (amount <= 0) {
      banner.showError($amountInput.attr('data-parsley-error-message'), true, 2500);
      $amountInput.addClass('invalid');
      returnValue = false;
    }
  }

  return returnValue;
}

function validateField (el) {
  let valid = true;

  // special field checks first

  // validate zip
  if (el.name === 'zip') {
    if (!validateZip(el.value)) {
      valid = false;
    }
  }

  if (el.name === 'email') {
    if (!validateDonorEmail(el.value)) {
      valid = false;
    }
  }

  // parsely validations
  if (!valid || !$(el).parsley().isValid(true)) {
    return false;
  }
  return true;
}

function validateZip (zip) {
  const country = $('#country').val();

  const usZipcodePattern = /^\d{5}(?:[-\s]\d{4})?$/;
  const postalcodePattern = /^[a-zA-Z\d\s-]+$/;

  if (country === 'US') {
    if (zip.length > 0 && !usZipcodePattern.test(zip)) {
      return false;
    }
  } else if (zip.length > 0 && !postalcodePattern.test(zip)) {
    return false;
  }

  return true;
}

const initBrainTreeHostedFields = () => {
  window.braintree.client.create({
    authorization: window.gon.braintree_token
  }, function (err, clientInstance) {
    if (err) {
      console.error(err);
      return;
    }
    initDeviceData(clientInstance);
    BraintreeHostedFields.create(clientInstance);
  });
};

initBrainTreeHostedFields();

let $applePayInstance;
const initApplePay = () => {
  if (!braintreeAvailable) {
    return;
  }

  if (!window.ApplePaySession) {
    $('.apple-pay-button').hide();
  }

  if (window.ApplePaySession && window.ApplePaySession.supportsVersion(3) && window.ApplePaySession.canMakePayments()) {
    console.log('apple pay available');

    window.braintree.client.create({
      authorization: window.gon.braintree_token
    }, function (clientErr, clientInstance) {
      if (clientErr) {
        console.error('Error creating client:', clientErr);
        return;
      }

      initDeviceData(clientInstance);
      window.braintree.applePay.create({
        client: clientInstance
      }, function (applePayErr, applePayInstance) {
        if (applePayErr) {
          console.error('Error creating applePayInstance:', applePayErr);
          return;
        }

        if (window.ApplePaySession) {
          console.log('apple pay instance!!');
          $applePayInstance = applePayInstance;
        }
      });
    });
  } else {
    console.log('apple pay unavailable');
  }
};

const $applePayButton = $('.apple-pay-button');

// When you click the apple pay button
$applePayButton.click(e => {
  console.log('apple button clicked');
  const paymentRequest = $applePayInstance.createPaymentRequest({
    total: {
      label: 'St. Baldrick\'s',
      amount: finalDonationAmount()
    },
    requiredBillingContactFields: ['postalAddress', 'name'],
    requiredShippingContactFields: ['email', 'phone']
  });

  $paymentForm.find('.inline-input .emtpy').removeClass('invalid');

  const session = new window.ApplePaySession(3, paymentRequest);
  session.onvalidatemerchant = function (event) {
    $applePayInstance.performValidation({
      validationURL: event.validationURL,
      displayName: 'St. Baldrick\'s'
    }, function (err, merchantSession) {
      if (err) {
        // You should show an error to the user, e.g. 'Apple Pay failed to load.'
        banner.showError('Apple Pay failed to load.', false, 4000);
        return;
      }
      session.completeMerchantValidation(merchantSession);
    });
  };

  session.onpaymentauthorized = function (event) {
    $applePayInstance.tokenize({
      token: event.payment.token
    }, function (tokenizeErr, payload) {
      if (tokenizeErr) {
        console.error('Error tokenizing Apple Pay:', tokenizeErr);
        session.completePayment(window.ApplePaySession.STATUS_FAILURE);
        return;
      }

      // Send payload.nonce to your server
      $('#payment_method_nonce').val(`${payload.nonce}`);
      $('#payment_gateway').val('braintree');
      // After you have transacted with the payload.nonce,
      // call `completePayment` to dismiss the Apple Pay sheet.
      session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
      console.log('setting applepay value');
      $('#payment_method').val('applepay');

      const payinfo = event.payment.billingContact;
      const shipinfo = event.payment.shippingContact;
      const countryString = (`${payinfo.countryCode}`).toUpperCase();

      log(payinfo);
      log(shipinfo);

      // concat with empty string to cast to string

      $('#cc_first_name').val(`${payinfo.givenName}`);
      $('#last_name').val(`${payinfo.familyName}`);
      $('#phone').val(`${shipinfo.phoneNumber}`);
      $('#email').val(`${shipinfo.emailAddress}`);

      $('#address1').val(`${payinfo.addressLines[0]}`);
      if (payinfo.addressLines[1]) {
        $('#address2').val(`${payinfo.addressLines[1]}`);
      }
      $('#city').val(`${payinfo.locality}`);

      if (dataISOCompliantCountries.includes(countryString)) {
        $('#state').val(payinfo.administrativeArea);
      } else {
        $('#region').val(payinfo.administrativeArea);
      }

      log(`${payinfo.locality}`);
      log(`${payinfo.administrativeArea}`);

      $('#country').val(countryString);
      $('#zip').val(`${payinfo.postalCode}`);

      disablePaymentButtons();
      log('disable payment buttons - applepay processing');

      postPaymentForm();
    });
  };

  session.begin();
});

initApplePay();

// Make sure to have https://pay.google.com/gp/p/js/pay.js loaded on your page
// You will need a button element on your page styled according to Google's brand guidelines
// https://developers.google.com/pay/api/web/guides/brand-guidelines
const paymentsClient = new google.payments.api.PaymentsClient({ // eslint-disable-line no-undef
  environment: window.gon.google_pay_env
});

const googlepayButtonWrapper = document.querySelector('#google-pay-button-wrapper');
const initGooglePay = () => {
  if (!braintreeAvailable) {
    return;
  }

  window.braintree.client.create(
    {
      authorization: window.gon.braintree_token
    },
    (clientErr, clientInstance) => {
      if (clientErr) {
        console.error('Error creating client:', clientErr);
        return;
      }

      initDeviceData(clientInstance);
      window.braintree.googlePayment.create(
        {
          client: clientInstance,
          googlePayVersion: 2,
          googleMerchantId: window.gon.google_pay_merchant_id // Optional in sandbox; if set in sandbox, this value must be a valid production Google Merchant ID
        },
        (googlePaymentErr, googlePaymentInstance) => {
          paymentsClient
            .isReadyToPay({
              // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest
              apiVersion: 2,
              apiVersionMinor: 0,
              allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest()
                .allowedPaymentMethods
            })
            .then((response) => {
              if (response.result) {
                // setup google pay butotn
                const button = paymentsClient.createButton({
                  buttonColor: 'black',
                  buttonType: 'plain',
                  buttonSizeMode: 'fill',
                  onClick: () => {}
                });
                if (googlepayButtonWrapper) {
                  googlepayButtonWrapper.appendChild(button);
                }

                button.addEventListener('click', (event) => {
                  event.preventDefault();
                  const paymentDataRequest = googlePaymentInstance.createPaymentDataRequest(
                    {
                      emailRequired: true,
                      transactionInfo: {
                        currencyCode: 'USD',
                        totalPriceStatus: 'FINAL',
                        totalPrice: finalDonationAmount()
                      }
                    }
                  );

                  // We recommend collecting billing address information, at minimum
                  // billing postal code, and passing that billing postal code with all
                  // Google Pay card transactions as a best practice.
                  // See all available options at https://developers.google.com/pay/api/web/reference/object
                  const cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0];
                  cardPaymentMethod.parameters.billingAddressRequired = true;
                  cardPaymentMethod.parameters.billingAddressParameters = {
                    format: 'FULL',
                    phoneNumberRequired: true
                  };

                  paymentsClient
                    .loadPaymentData(paymentDataRequest)
                    .then((paymentData) => {
                      googlePaymentInstance.parseResponse(paymentData, (err, result) => {
                        if (err) {
                          // Handle parsing error
                          console.error(err);
                        }
                        // Send result.nonce to your server
                        // result.type may be either "AndroidPayCard" or "PayPalAccount", and
                        // paymentData will contain the billingAddress for card payments

                        // Send payload.nonce to your server
                        $('#payment_method_nonce').val(`${result.nonce}`);
                        $('#payment_gateway').val('braintree');

                        // After you have transacted with the payload.nonce,
                        $('#payment_method').val('googlepay');

                        if (!window.sbf.logged_in) {
                          const payinfo = paymentData.paymentMethodData.info.billingAddress;
                          // concat with empty string to cast to string
                          const firstName = payinfo.name.split(' ').slice(0, -1).join(' ');
                          const lastName = payinfo.name.split(' ').slice(-1).join(' ');

                          $('#cc_first_name').val(`${firstName}`).change();
                          $('#last_name').val(`${lastName}`).change();

                          $('#address1')
                            .val(`${payinfo.address1}`)
                            .change();
                          if (payinfo.address2) {
                            $('#address2')
                              .val(`${payinfo.address2}`)
                              .change();
                          }
                          $('#city')
                            .val(`${payinfo.locality}`)
                            .change();
                          $('#zip')
                            .val(`${payinfo.postalCode}`)
                            .change();
                          $('#phone')
                            .val(`${payinfo.phoneNumber}`)
                            .change();

                          if (paymentData.email) {
                            $('#email')
                              .val(`${paymentData.email}`)
                              .change();
                          }
                          $('#country')
                            .val(payinfo.countryCode.toUpperCase())
                            .change();

                          if (dataISOCompliantCountries.includes(payinfo.countryCode)) {
                            $('#state')
                              .val(`${payinfo.administrativeArea}`)
                              .change();
                          } else {
                            $('#region')
                              .val(`${payinfo.administrativeArea}`)
                              .change();
                          }
                        }
                        disablePaymentButtons();
                        postPaymentForm();
                      });
                    })
                    .catch((err) => {
                      console.error('catch', err);
                      // Handle errors
                    });
                });
              }
            })
            .catch((err) => {
              console.error('catch', err);
              // Handle errors
            });
        }
      );
    }
  );
};

initGooglePay();

function finalDonationAmount () {
  if ($('#amount_with_fee').val() === undefined || $('#amount_with_fee').val().length === 0) {
    return $donationAmountField.val();
  } else {
    return $('#amount_with_fee').val();
  }
}

function validateDonorEmail (email) {
  const emailPattern = /^(?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+([.][a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]*)+|["](?:[^\\x01-\\x08\\x11\\x12\\x14-\\x1f\\x7f\\x0d\\x22\\x5c]|(\\x5c[\\x01-\\x09\\x11\\x12\\x14-\\x7f]))+["]|(?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+|["](?:[^\\x01-\\x08\\x11\\x12\\x14-\\x1f\\x7f\\x0d\\x22\\x5c]|(\\x5c[\\x01-\\x09\\x11\\x12\\x14-\\x7f]))+["])([.](?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+|["](?:[^\\x01-\\x08\\x11\\x12\\x14-\\x1f\\x7f\\x0d\\x22\\x5c]|(\\x5c[\\x01-\\x09\\x11\\x12\\x14-\\x7f]))+["]))*)@(?:([A-Za-z0-9-]{1,63}[.])+[A-Za-z]{2,})$/;
  if (!emailPattern.test(email)) {
    return false;
  }
  return true;
}

function postPaymentForm () {
  const data = $paymentForm.serialize();
  const donationType = $('#donation_type').val();

  // get the user's first name to pass to the thank you page
  let firstName = $('#give_profile_first_name').val() || '';
  if (!firstName.length) { firstName = $('#cc_first_name').val(); }

  // The info to be sent is in the data variable, which contains
  // all CC details and an array of donation IDs

  $.ajax({
    type: 'post',
    dataType: 'json',
    data,
    url: '/donate/widget/payment.json',
    beforeSend: function (xhr) {
      disablePaymentButtons();
      log('disable payment buttons - postPaymentForm');
      banner.showSaving('Processing your donation...', false, false);
    },
    success: function (result) {
      log('success!');
      banner.close();

      // Send user to give thank you page
      let thankYouUrl = '/donate/thankyou';
      let donationId;

      if (donationType === 'monthly' && result.donations.length) {
        donationId = result.donations[0].id;
      } else if (donationType !== 'monthly' && result.id) {
        donationId = result.id;
      }

      if (donationId) {
        thankYouUrl += `?name=${encodeURIComponent(firstName)}&amount=${finalDonationAmount()}&type=${donationType}&id=${donationId}&origin=widget`;
      }

      window.top.location.href = thankYouUrl;

      // // In-Widget Thank you page
      // var donationReceiptLink = $('#donation_receipt_link');
      // var _href = donationReceiptLink.attr('href');
      // var donationId;

      // // Fixes widget flashing thank you page before resetting
      // window.history.replaceState({}, 'Done!', '/donate/widget?thanks=true');
      // try {
      //   window.parent.sbfDonateWidgetCurrentUrl = '/donate/widget?thanks=true';
      // } catch (error) {
      //   log('Error: ' + error);
      // }

      // var formattedAmount;
      // if ($('#amount_with_fee').val() === undefined || $('#amount_with_fee').val().length === 0) {
      //   formattedAmount = formatAmount($donationAmountField.val());
      // } else {
      //   formattedAmount = formatAmount($('#amount_with_fee').val());
      // }

      // $('#firstNameThanks').text(firstName);
      // $('#amountThanks').text(formattedAmount);

      // $('#step_id_container').addClass('thank-you-step');
      // $('#top-hr').addClass('thank-you-step');
      // $stepDetailsContainer.hide();
      // // changing body background on thank you step
      // $('body').css('background', '#7f7f7f');

      // if (donationType === 'monthly' && result.donations.length) {
      //   donationId = result.donations[0].id;
      // } else if (donationType !== 'monthly' && result.id) {
      //   donationId = result.id;
      // }

      // // Set the receipt link
      // donationReceiptLink.attr('href', _href + donationId);

      // // Since We already have a successful charge just closing payment info
      // // step and showing the Thank You page, Trying to go through the nextStep
      // // function was trying to validate form and causing Paypal issues
      // hideStep(3);
      // showStep(4);
    },
    error: function (xhr) {
      log(xhr);
      banner.showError('Unable to process this credit card.', true);
      $paymentButton.prop('disabled', false);
      enablePaymentButtons();
      log('enabled payment buttons - postPaymentForm error');
      $('.prev-step').prop('disabled', false);
      // Remove payment fields on error
      BraintreeHostedFields.clearFields();

      $('#donation_fee_covered').prop('checked', false);
    },
    complete: function (xhr) {}
  });
}
